import { command } from "@lookiero/messaging";
const PLAY_GAME = "play_game";
const playGame = ({ aggregateId, ...payload }) => ({
    ...command({ aggregateId, name: PLAY_GAME }),
    ...payload,
});
export { PLAY_GAME, playGame };
